import queryString from 'query-string';

export const wfs = ({
  version,
  namespace,
  request,
  typename,
  count,
  propertyName,
  // eslint-disable-next-line camelcase
  cql_filter,
  geometry,
}) => {
  const args = {
    version,
    propertyName,
    service: 'WFS',
    outputFormat: 'json',
    request,
    typename: `${namespace}:${typename}`,
    CQL_FILTER: cql_filter,
    count,
    geometry,
  };

  const url = `/geoserver/${namespace}/ows?${queryString.stringify(args)}`;
  return url;
};
